<template>
    <div class="InstagramBusinessContentFeed">
        <section>
            <div class="flex justify-between items-baseline mb-6">
                <h3 class="font-medium not-italic m-0">
                    <slot name="heading"></slot>
                </h3>
                <select
                    v-model="displayItems"
                    class="form-control max-w-2xs border-gray-300"
                    aria-label="Antal opslag"
                >
                    <option :value="10">
                        Seneste 10 opslag
                    </option>
                    <option :value="25">
                        Seneste 25 opslag
                    </option>
                    <option :value="50">
                        Seneste 50 opslag
                    </option>
                </select>
            </div>

            <Highcharts ref="highcharts" :options="options" />
        </section>

        <div ref="tooltip" class="hidden">
            <div class="InstagramBusinessContentFeed__tooltip">
                <InstagramBusinessContentCard class="flex-1" :content="tooltipContent" />
            </div>
        </div>
    </div>
</template>

<style type="text/less" lang="less">
@import '~dashboard-less/variables';
@import '~dashboard-less/spark/utilities';

.InstagramBusinessContentFeed__tooltip {
    @apply rounded-lg text-white p-1;

    background-color: @brand-primary;
    width: 200px;

    .fa-comment-o {
        color: lighten(@brand-primary, 90%);
    }
}
</style>

<script>
import { optional } from 'dashboard-js/helpers'
import HasSubscriptions from 'dashboard-js/mixins/HasSubscriptions'
import InstagramBusinessContentCard from 'dashboard-js/components/influencers/InstagramBusinessContentCard'
import ResponsiveValue from 'dashboard-js/app/ResponsiveValue'
import Tooltip from 'dashboard-js/directives/Tooltip'
import collect from 'collect.js'

export default {
    components: { InstagramBusinessContentCard },

    directives: { Tooltip },

    mixins: [HasSubscriptions],

    props: ['contents'],

    data() {
        const generateTooltipHtml = (content, callback) => {
            // Schedule callback with updated tooltip
            this.tooltipContent = content
            this.$nextTick(() => callback(this.$refs.tooltip.innerHTML))

            // Return initial empty tooltip
            return this.$refs.tooltip.innerHTML
        }

        return {
            tooltipContent: null,
            displayItems: null,
            options: {
                plotOptions: {
                    column: {
                        pointWidth: 15,
                        minPointLength: 5,
                    },
                },
                chart: {
                    type: 'column',
                },
                title: {
                    text: '',
                },
                tooltip: {
                    shared: true,
                    enabled: true,
                    useHTML: true,
                    valueDecimals: 2,
                    shadow: true,
                    hideDelay: 500,
                    outside: true,
                    backgroundColor: 'var(--magic-color)',
                    borderRadius: 40,
                    padding: 0,
                    formatter(tooltip) {
                        const content = this.points[0].point.content

                        return generateTooltipHtml(content, html => {
                            $(tooltip.container)
                                .find('.InstagramBusinessContentFeed__tooltip')
                                .replaceWith(html)
                        })
                    },
                },
                xAxis: {
                    minorGridLineWidth: 0,
                    minorTickLength: 0,
                    tickLength: 0,
                    type: 'category',
                    uniqueNames: false,
                },
                credits: {
                    enabled: false,
                },
                yAxis: {
                    minorTickLength: 0,
                    tickLength: 0,
                    title: {
                        text: '',
                    },
                    labels: {
                        format: '{value:,.0f}',
                    },
                },
                legend: {
                    enabled: false,
                },
                series: [
                    {
                        name: '',
                        color: 'var(--magic-color)',
                        data: [],
                    },
                ],
            },
        }
    },

    watch: {
        displayItems(value) {
            this.updateFeed(value)
        },
    },

    mounted() {
        this.subscribe(
            new ResponsiveValue(10)
                .sm(25)
                .xl(50)
                .get(),
            limit => (this.displayItems = limit)
        )
    },

    methods: {
        updateFeed(limit) {
            const data = collect(this.contents)
                .sortBy(content => content.media_published_at)
                .take(-limit)
                .map(item => ({
                    name: moment(item.media_published_at).format('DD.MM'),
                    y: optional(item.latest_stat.views_total, 0),
                    content: item,
                })).items

            this.$refs.highcharts.chart.series[0].setData(data, true)
        },
    },
}
</script>
